// Labels and tones for Growth › Analytics and Lead finder.

import type { Candidate, CandidateSort, CandidateStatus, RunStatus, SearchKind } from '@/api/growthInsights'
import type { BadgeTone } from '@/components/ui'

export const CANDIDATE_STATUS_LABELS: Record<CandidateStatus, string> = { new: 'New', added: 'Added', rejected: 'Rejected', duplicate: 'Duplicate' }
export const CANDIDATE_STATUS_TONE: Record<CandidateStatus, BadgeTone> = { new: 'accent', added: 'good', rejected: 'outline', duplicate: 'neutral' }

export const CANDIDATE_SORT_OPTIONS: Array<{ value: CandidateSort; label: string }> = [
  { value: '-priority', label: 'Highest priority' },
  { value: '-confidence', label: 'Highest confidence' },
  { value: '-created_at', label: 'Newest first' },
  { value: 'name', label: 'Name A–Z' },
]

export const RUN_STATUS_LABELS: Record<RunStatus, string> = { running: 'Running', done: 'Done', stopped: 'Stopped', failed: 'Failed' }
export const RUN_STATUS_TONE: Record<RunStatus, BadgeTone> = { running: 'accent', done: 'good', stopped: 'warn', failed: 'bad' }

export const SOURCE_LABELS: Record<string, string> = { manual: 'Pasted', web_search: 'Web search', recleague: 'RecLeague', quickscores: 'QuickScores', preview: 'Preview data', activity: 'Activity check' }

export const SEARCH_KIND_LABELS: Record<SearchKind, string> = { youth: 'Youth leagues', church: 'Church leagues', rec: 'Rec leagues' }

/** What became of a page, in words. A later outcome still shows, as its key. */
export const OUTCOME_LABELS: Record<string, string> = {
  candidate: 'New candidate',
  duplicate: 'Already a lead',
  seen: 'Seen before',
  suppressed: 'Do not contact',
  stored_only: 'Stored only',
  search: 'Search',
  preview: 'Read',
  active: 'Active',
  stale: 'Stale',
  unknown: 'Unknown',
  later: 'Try again',
  decided: 'Decided by hand',
  person_page: 'About people',
  no_name: 'No name',
  not_league: 'Not a league',
  robots: 'robots.txt',
  ssrf: 'Blocked address',
  budget: 'Budget used',
  timeout: 'Timed out',
  too_large: 'Too large',
  not_html: 'Not a page',
  http_error: 'Error',
  login: 'Login',
  captcha: 'CAPTCHA',
  paywall: 'Paywall',
  rate_limited: 'Slow down',
  redirects: 'Too many redirects',
  network: 'Unreachable',
  error: 'Failed',
}

export const OUTCOME_TONE: Record<string, BadgeTone> = { candidate: 'good', duplicate: 'neutral', seen: 'neutral', preview: 'good', search: 'neutral', suppressed: 'bad', ssrf: 'bad', active: 'good', stale: 'warn', unknown: 'neutral', later: 'warn' }

export function candidatePlace(c: Pick<Candidate, 'city' | 'state' | 'country'>): string | null {
  return [c.city, c.state].filter(Boolean).join(', ') || c.country || null
}
